var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaintbrush(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49658 13.375C9.49658 11.9688 10.1528 10.6562 11.2778 9.8125L22.3872 1.46875C23.231 0.8125 24.4497 0.90625 25.2466 1.60938C26.0435 2.35938 26.1841 3.57812 25.6216 4.51562L18.0278 16.2344C17.3247 17.3125 16.1528 18.0625 14.8872 18.25L9.49658 13.375ZM13.9966 19.75C13.9966 22.6562 11.606 25 8.74658 25H1.99658C1.15283 25 0.496582 24.3438 0.496582 23.5C0.496582 22.7031 1.15283 22 1.99658 22H2.18408C3.02783 22 3.59033 21.1562 3.49658 20.3125C3.49658 20.125 3.49658 19.9375 3.49658 19.75C3.49658 16.9375 5.69971 14.6406 8.51221 14.5469L13.9497 19.4219C13.9497 19.5156 13.9966 19.6562 13.9966 19.75Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaintbrush);
export default __webpack_public_path__ + "static/media/paintbrush.8c8b9c1165fc8be0d6d741908dc1e66b.svg";
export { ForwardRef as ReactComponent };